import React from 'react';
import PropTypes from 'prop-types';

import SmartChart from '../../../../components/Chart/SmartChart';
import { numberToHumanChart } from '../../../../utils/formatter';

import {
  combinedChartConfig,
  COMBINED_DOWNLOADS_COLOR,
  COMBINED_REVENUE_COLOR,
} from './chart-configs';

const legendAbbr = (value) =>
  numberToHumanChart(value, { precision: 1, strip_insignificant_zeros: true });

const buildAvgSeries = (timeSeries, avgValue) => {
  if (!timeSeries || timeSeries.length === 0) return [];
  const [firstX] = timeSeries[0];
  const [lastX] = timeSeries[timeSeries.length - 1];
  return [
    [firstX, avgValue],
    [lastX, avgValue],
  ];
};

const CombinedChart = ({ data }) => {
  const series = {
    downloads: data.downloads || [],
    downloadsAvg: buildAvgSeries(data.downloads, data.avg?.downloads),
    revenue: data.total_revenue || [],
    revenueAvg: buildAvgSeries(data.total_revenue, data.avg?.total_revenue),
  };

  const metaSeriesData = {
    downloads: { name: 'Downloads', type: 'spline', color: COMBINED_DOWNLOADS_COLOR, yAxis: 0 },
    downloadsAvg: {
      name: `Average Downloads (${legendAbbr(data.avg?.downloads || 0)})`,
      type: 'spline',
      color: COMBINED_DOWNLOADS_COLOR,
      dashStyle: 'Dash',
      lineWidth: 1,
      enableMouseTracking: false,
      yAxis: 0,
    },
    revenue: { name: 'Revenue', type: 'spline', color: COMBINED_REVENUE_COLOR, yAxis: 1 },
    revenueAvg: {
      name: `Average Revenue ($${legendAbbr(data.avg?.total_revenue || 0)})`,
      type: 'spline',
      color: COMBINED_REVENUE_COLOR,
      dashStyle: 'Dash',
      lineWidth: 1,
      enableMouseTracking: false,
      yAxis: 1,
    },
  };

  return (
    <SmartChart series={series} metaSeriesData={metaSeriesData} config={combinedChartConfig} />
  );
};

CombinedChart.propTypes = {
  data: PropTypes.object.isRequired,
};

export default CombinedChart;
